'use strict';

exports.__esModule = true;

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _trackEnums = require('./track-enums');

var _track = require('./track');

var _track2 = _interopRequireDefault(_track);

var _utilsMergeOptions = require('../utils/merge-options');

var _utilsMergeOptions2 = _interopRequireDefault(_utilsMergeOptions);

var _utilsBrowserJs = require('../utils/browser.js');

var browser = _interopRequireWildcard(_utilsBrowserJs);

/**
 * A single video text track as defined in:
 * @link https://html.spec.whatwg.org/multipage/embedded-content.html#videotrack
 *
 * interface VideoTrack {
 *   readonly attribute DOMString id;
 *   readonly attribute DOMString kind;
 *   readonly attribute DOMString label;
 *   readonly attribute DOMString language;
 *   attribute boolean selected;
 * };
 *
 * @param {Object=} options Object of option names and values
 * @class VideoTrack
 */

var VideoTrack = (function (_Track) {
  _inherits(VideoTrack, _Track);

  function VideoTrack() {
    var options = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

    _classCallCheck(this, VideoTrack);

    var settings = _utilsMergeOptions2['default'](options, {
      kind: _trackEnums.VideoTrackKind[options.kind] || ''
    });

    // on IE8 this will be a document element
    // for every other browser this will be a normal object
    var track = _Track.call(this, settings);
    var selected = false;

    if (browser.IS_IE8) {
      for (var prop in VideoTrack.prototype) {
        if (prop !== 'constructor') {
          track[prop] = VideoTrack.prototype[prop];
        }
      }
    }

    Object.defineProperty(track, 'selected', {
      get: function get() {
        return selected;
      },
      set: function set(newSelected) {
        // an invalid or unchanged value
        if (typeof newSelected !== 'boolean' || newSelected === selected) {
          return;
        }
        selected = newSelected;
        this.trigger('selectedchange');
      }
    });

    // if the user sets this track to selected then
    // set selected to that true value otherwise
    // we keep it false
    if (settings.selected) {
      track.selected = settings.selected;
    }

    return track;
  }

  return VideoTrack;
})(_track2['default']);

exports['default'] = VideoTrack;
module.exports = exports['default'];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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